/**
 * @fileOverView
 * @description Org Members Collection<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var RestCollection = require('ampersand-rest-collection');
var OrgMember = require("../models/orgmember");
var config = require("../etc/config");
var app = require('ampersand-app');

var OrgMembers = RestCollection.extend({

    model: OrgMember,

    indexes: ['key','personKey'],

    url: function(){
        return config.restApiUrl + "/org/members";
    },

    //org administration is always done as yourself, never in org context
    ajaxConfig: app.utils.setPersonalAuthTokenHeader,

    //revoked/declined rows stay in the table for re-invites; hide them here
    parse: function(response){
        if(!Array.isArray(response)) return response;
        var rows = response.filter(function(m){
            return m.status == 'invited' || m.status == 'active';
        });
        //remembered so seat counts survive a search filtering the list down
        if(!this.searchQuery) app.orgSeatsUsed = rows.length;
        return rows;
    }

});

module.exports = OrgMembers;
